import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase';

// Board-Meldung nach dem Speichern von Punktesystem oder Bonusfragen-
// Konfiguration (Text unverändert aus dem früheren AdminPanel).
export async function postePunktesystemAufBoard(userProfile, saison, punkte, bonus) {
  const pre = bonus?.preSeasonPredictions || {};
  const po = bonus?.playoffPredictions || {};
  const aktiveBonusfragen = [];
  if (pre.divisionWinners?.aktiv) aktiveBonusfragen.push(`• Division Winners: ${pre.divisionWinners.punkte} Punkte`);
  if (pre.conferenceSeed1?.aktiv) aktiveBonusfragen.push(`• Conference #1 Seeds: ${pre.conferenceSeed1.punkte} Punkte`);
  if (pre.wildCardTeams?.aktiv) aktiveBonusfragen.push(`• Wild Card Teams: ${pre.wildCardTeams.punkte} Punkte`);
  if (pre.superBowlWinner?.aktiv) aktiveBonusfragen.push(`• Super Bowl Winner: ${pre.superBowlWinner.punkte} Punkte`);
  if (pre.mvp?.aktiv) aktiveBonusfragen.push(`• MVP: ${pre.mvp.punkte} Punkte`);
  if (po.conferenceChampionshipTeams?.aktiv) aktiveBonusfragen.push(`• Conference Championship Teams: ${po.conferenceChampionshipTeams.punkte} Punkte`);
  if (po.superBowlTeams?.aktiv) aktiveBonusfragen.push(`• Super Bowl Teams: ${po.superBowlTeams.punkte} Punkte`);

  const nachricht = `🔔 ADMIN-MELDUNG: Punktesystem für Saison ${saison} wurde aktualisiert!

📊 SPIELTIPPS:
- Exakter Tipp: ${punkte.basis.exakterTipp} Punkte
- Richtige Tendenz: ${punkte.basis.richtigeTendenz} Punkte
- Richtiger Sieger: ${punkte.basis.richtigerSieger} Punkte
${punkte.ot?.aktiv ? '• OT-System: AKTIV' : ''}
${punkte.heimAuswaerts?.aktiv ? '• Heim/Auswärts-Bonus: AKTIV' : ''}
${punkte.perfekteWoche?.aktiv ? `• Perfekte Woche: ${punkte.perfekteWoche.bonus} Punkte` : ''}
${punkte.playoffMultiplikator?.aktiv ? '• Playoff-Multiplikator: AKTIV' : ''}

🎯 BONUSFRAGEN (${aktiveBonusfragen.length} aktiv):
${aktiveBonusfragen.join('\n')}

Viel Erfolg beim Tippen! 🏈`;

  await addDoc(collection(db, 'boardNachrichten'), {
    autor: userProfile?.displayName || 'Admin',
    autorId: userProfile?.uid || 'system',
    text: nachricht,
    timestamp: serverTimestamp(),
    istAdmin: true,
    saison
  });
}
